module.exports = __webpack_public_path__ + "img/21.dccf5ce6.jpg";